<template>
  <div>
    <button class="btn btn-primary mb-2" v-if="subscription" @click="close_subscription()">
      <i class="fa fa-arrow-left"></i><span>{{ 'back' | t }}</span>
    </button>
    <div class="card" v-if="!subscription">
      <div class="card-body">
        <h4>{{ 'replaced_subscriptions' | t | titlecase }}</h4>
      </div>
      <table class="table table-hover table-response">
        <thead>
          <tr>
            <th>{{ 'name' | t }}</th>
            <th>{{ 'activation_time' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="subscription in replaced_subscriptions" @click="open_subscription(subscription)">
            <td>{{ subscription.name }}</td>
            <td>{{ subscription.activation_time | datetime }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="subscription">
      <subscription-form
        :subscription="subscription"
        :customer="customer"
        :currency="customer.currency"
        :customer_id="customer.id"
      ></subscription-form>
    </div>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';
export default {
  props: ['replaced_subscriptions', 'customer'],
  data: function () {
    return {
      subscription: null
    };
  },
  methods: {
    open_subscription(subscription) {
      this.subscription = subscription;
    },
    close_subscription() {
      this.subscription = null;
    }
  }
};
</script>

<style scoped>
.index-table td {
  max-width: 110px;
}

tbody tr {
  cursor: pointer;
}
</style>
